import { IEventAggregationService } from 'interfaces/event-aggregation-service/event-aggregation-service.interface';

import { FavouriteAdded } from '@studyportals/wishlist-service-core';
import { WishlistCache } from '../infrastructure/wishlist-cache';
import { WebSocketFavouriteAddedSubscriber } from './websocket-favourite-added-subscriber';

export class WebSocketFavouriteAddedAdapter {

	constructor(
		private readonly eventAggregationService: IEventAggregationService,
		private wishlistCache: WishlistCache) {
	}

	public initialize(): void {
		this.eventAggregationService.subscribeToWebSocketEvent(
			FavouriteAdded.eventName,
			new WebSocketFavouriteAddedSubscriber(
				this.eventAggregationService,
				this.wishlistCache,
			),
		);
	}
}
